import baseApi from "@/api/baseApi";
import { transformDownload } from "@/helpers/saveFile";

const api = {
  async download(documentId: string, useAlbumUser = false): Promise<any> {
    const response = await baseApi({
      method: "get",
      url: `/ibm/document/download/${documentId}?useAlbumUser=${useAlbumUser}`,
      responseType: "blob",
      transformResponse: transformDownload,
    });

    return response.data;
  },
};

export default api;
